import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Gem, Plus, Layers } from "lucide-react";
import { NewBrandDialog } from "@/pages/app/Brands";

const STATUS_TONES = { active: "border-emerald-500/40 text-emerald-700", paused: "border-amber-500/40 text-amber-700", archived: "border-border text-muted-foreground" };

export default function ClientBrandsTab({ clientId }) {
  const { activeWorkspaceId } = useAuth();
  const [brands, setBrands] = useState(null);
  const [creating, setCreating] = useState(false);

  const load = () => api.get(`/clients/${clientId}/brands`).then((r) => setBrands(r.data || [])).catch(() => setBrands([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [clientId]);

  return (
    <div className="space-y-3" data-testid="client-brands-tab">
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{brands ? `${brands.length} brand(s) linked to this client` : "Loading…"}</span>
        <Button size="sm" className="rounded-none" onClick={() => setCreating(true)} data-testid="client-new-brand-btn"><Plus className="w-3.5 h-3.5 mr-1.5" /> New brand</Button>
      </div>
      {brands && brands.length === 0 && (
        <div className="border border-dashed border-border p-8 text-center text-sm text-muted-foreground" data-testid="client-brands-empty">
          No brands yet for this client. Create one to define strategy, voice, guidelines & more.
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {(brands || []).map((b) => (
          <Link key={b.id} to={`/app/brands/${b.id}`} className="border border-border p-4 hover:border-primary transition-colors block" data-testid={`client-brand-card-${b.id}`}>
            <div className="flex items-start gap-3">
              {b.logo_url
                ? <img src={b.logo_url} alt={b.name} className="w-9 h-9 object-contain border border-border bg-white" />
                : <div className="w-9 h-9 border border-border bg-muted/40 flex items-center justify-center"><Gem className="w-4 h-4 text-muted-foreground" /></div>}
              <div className="min-w-0 flex-1">
                <div className="font-semibold truncate">{b.name}</div>
                <div className="text-xs text-muted-foreground inline-flex items-center gap-1"><Layers className="w-3 h-3" />{b.pillars_count} pillars · {b.competitors_count} competitors</div>
              </div>
              <Badge variant="outline" className={`rounded-none text-[10px] ${STATUS_TONES[b.status] || ""}`}>{b.status}</Badge>
            </div>
          </Link>
        ))}
      </div>
      {creating && <NewBrandDialog wsId={activeWorkspaceId} clients={[]} defaultClientId={clientId} onClose={() => setCreating(false)} onCreated={load} />}
    </div>
  );
}
